



























































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import headPanel from "./components/headPanel.vue";
import { logoutPanel, versionSpecsPanel } from "@/components";
import { TbNotice, TbOrderPad, TbShop, TbTransferOrder } from "@/http";
import { Toast, Dialog } from "vant";
import dayjs from "dayjs";
import { fmoney } from "@/common/money";
import echarts from "echarts";
import { fontStyle } from "html2canvas/dist/types/css/property-descriptors/font-style";
var md5 = require("js-md5");
@Component({
  components: {
    headPanel,
    logoutPanel,
    versionSpecsPanel,
  },
})
export default class mainPage extends Vue {
  dialogShow = false;
  public $refs: {};

  fmoney = fmoney;
  gg_tit = "";
  gg_con = "";
  selkjdate = new Date();
  selshowdate = dayjs(new Date()).format("YYYY年MM月");
  curseldate = dayjs(new Date()).format("YYYY-MM");
  isshow = true;
  calshow = false;
  minDate = new Date(new Date().getFullYear() - 1, 0, 1);
  maxDate = new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );
  numform: any = { totalSaleAmount: 0 };
  authlist = JSON.parse(localStorage.getItem("padUserinfo")).authorityJson.split(",");
  tippwdshow = false;
  pwd = "";
  userinfo: any = {};
  activechart = 0;

  machart = null;
  y_data = [];
  x_data = [];
  hotgoodslist = [];

  //调拨入库数量
  innum = null;

  userInfo = {};

  /**app-版本信息 */
  versionIno: any = {};
  /**是否强制更新 */
  isMust = false;
  /**是否开通网店 */
  isOnline=false;
  /**网店订单数 */
  onlineOrderNum=0;
  /**数据指标提示 */
	  tipDatashow=false

  async created() {
    this.userInfo = JSON.parse(localStorage.getItem("padUserinfo"));
    await this.init();
    await this.getmainData();
    if (this.activechart == 0) {
      await this.getchartdata();
    }
    this.userinfo = JSON.parse(localStorage.getItem("padUserinfo"));
    if (localStorage.getItem("maindataisshow") == "hide") {
      this.isshow = false;
    }
    let obj = {
      outShopId: "",
      transferStatus: null,
      start: "",
      end: "",
      skip: 0,
      count: -1,
      receiveShopId: this.userinfo.shopId,
    };
    let res = await TbTransferOrder.GetTbTransferOrderListV2(obj);
    this.innum = res.items.filter((v) => v.transferStatus == 1).length;
    // console.log("res最初this.innum", this.innum);
  }
  mounted() {
    this.getOnlineAuth();
    this.curseldate = dayjs(new Date()).format("YYYY-MM");
    window['localVersion'] = (val) => {
      this.localVersion(val)
    }
    if (localStorage.getItem('versionIno')) {
      let versionIno = JSON.parse(localStorage.getItem('versionIno'));
      this.versionIno = versionIno;
    }
  }

  localVersion(val) {
    // Toast('localVersion,'+val);
    localStorage.setItem('nowVersion', val);
    if (localStorage.getItem('versionIno')) {
      let versionIno = JSON.parse(localStorage.getItem('versionIno'));
      this.versionIno = versionIno;
      this.isMust = versionIno.minimumVersion == versionIno.latestVersion ? true : false;
      if (versionIno.latestVersion != val) {
        this.$refs['versionSpecsPanel'].showFun();
      }

    }
  }

  async init() {
    try {
      let res = await TbNotice.GetTbNoticeList({
        skip: 0,
        count: -1,
      });
      let arr = res.items.filter((v) => v.notificationStatus == 2);
      this.gg_tit = arr[0].noticeTitle;
      this.gg_con = this.stripHTMLTags(arr[0].noticeContent);
    } catch (error) { }
  }
  stripHTMLTags(html) {
    let str = html.replace(/<img[^>]*>/g, "");
    return str;
  }
  async getmainData() {
    try {
      let res = await TbOrderPad.GetOrderHomepage({
        shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
        date: this.curseldate,
      });
      this.numform = res;
    } catch (error) { }
  }
  async getchartdata() {
    try {
      let res = await TbOrderPad.GetLineChart({
        shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
        date: this.curseldate,
      });
      this.y_data = res.data.map((v) => fmoney(v.salesAmount, 2));
      this.x_data = res.data.map((v) => Number(dayjs(v.date).format("DD")));
      this.drawFun();
    } catch (error) { }
  }
  async gethotgoods() {
    try {
      let res = await TbOrderPad.GetHotGoods({
        shopId: JSON.parse(localStorage.getItem("padUserinfo")).shopId,
        date: this.curseldate,
      });
      this.hotgoodslist = res.data;
      if (this.hotgoodslist.length > 6) {
        this.hotgoodslist = this.hotgoodslist.slice(0, 6);
      }
    } catch (error) { }
  }
  logoutFun() {
    this.dialogShow = true;
  }

  cancelFun() {
    this.dialogShow = false;
  }
  confimrFun() {
    this.dialogShow = false;
    localStorage.removeItem("padUserinfo");
    localStorage.removeItem("padToken");
    this.$router.push("/pad/padLogin2");
  }
  goPage(type) {
    switch (type) {
      case 1:
        if (!this.hasallAuth(["101", "201"])) {
          Toast("暂无商品查看权限，请联系管理员");
          return;
        }
        this.$router.push("/pad/product/index");
        break;
      case 2:
        if (!this.hasallAuth(["301", "401", "501"])) {
          Toast("暂无会员查看权限，请联系管理员");
          return;
        }
        this.$router.push("/pad/vip/index");
        break;
      case 3:
        if (!this.hasallAuth(["801", "901", "1001"])) {
          Toast("暂无员工查看权限，请联系管理员");
          return;
        }
        this.$router.push("/pad/staff/index");
        break;
      case 4:
        if (!this.hasallAuth(["2001", "2101", "2201"])) {
          Toast("暂无库存查看权限，请联系管理员");
          return;
        }
        this.$router.push("/pad/stock/index");
        break;
      case 5:
        if (!this.hasallAuth(["601", "2501", "701"])) {
          Toast("暂无收银台查看权限，请联系管理员");
          return;
        }
        this.$router.push("/pad/cashier/index");
        break;
      case 6:
        if (!this.hasallAuth(["2402", "2404"])) {
          Toast("暂无调拨查看权限，请联系管理员");
          return;
        }
        this.$router.push("/pad/allot/index");
        break;
      case 7:
        this.$router.push("/pad/changeShifts/index");
        break;
      case 8:
        if (!this.hasallAuth(["2601", "1601", "1701", "1801", "1901"])) {
          Toast("暂无报表查看权限，请联系管理员");
          return;
        }
        this.$router.push("/pad/report/index");
        break;
      case 9:
        this.$router.push("/pad/setting/index");
        break;
      default:
        break;
    }
  }
  /**判权限 */
  hasallAuth(auth) {
    let val = false;
    let btnPermissionsStr = this.userInfo["authorityJson"].split(",");
    if (btnPermissionsStr == undefined || btnPermissionsStr == null) {
      val = false;
    }
    btnPermissionsStr.map((v) => {
      auth.map((z) => {
        if (v == z) {
          val = true;
        }
      });
    });
    return val;
  }
  stripHtmlTags(htmlContent) {
    return htmlContent.replace(/<[^>]*>/g, "");
  }
  gotoGG() {
    if (!this.gg_tit) {
      Toast("暂无通知");
      return;
    }
    this.$router.push("/pad/notice/index");
  }
  opencal() {
    this.calshow = true;
  }
  formatter(type, value) {
    if (type === "year") {
      return `${value}年`;
    }
    if (type === "month") {
      return `${value}月`;
    }
    return `${value}日`;
  }
  onClose() {
    this.calshow = false;
  }
  Confirm(value) {
    console.log(value);
    this.selkjdate = value;
    this.selshowdate = dayjs(value).format("YYYY年MM月");
    this.curseldate = dayjs(value).format("YYYY-MM");
    this.getmainData();
    if (this.activechart == 0) {
      this.getchartdata();
    }
    if (this.activechart == 1) {
      this.gethotgoods();
    }
    this.calshow = false;
  }
  showdata(tag) {
    if (this.authlist.includes("001")) {
      if (tag == 2) {
        this.pwd = "";
        this.tippwdshow = true;
      } else {
        this.isshow = false;
        localStorage.setItem("maindataisshow", "hide");
      }
    } else {
      Dialog.alert({
        title: "提示",
        message: "暂无操作权限",
        confirmButtonText: "确定",
        confirmButtonColor: "#0491A7",
      }).then(() => {
        // on close
      });
    }
    console.log(this.isshow);
  }
  exit_pwd() {
    this.tippwdshow = false;
  }
  pwdconfirm() {
    let pwduser = JSON.parse(localStorage.getItem("padUserinfo")).pwd;
    if (md5(this.pwd) == pwduser.toUpperCase().toLowerCase()) {
      this.isshow = true;
      if (this.activechart == 0 && this.authlist.includes("006")) {
        this.getchartdata();
      }
      if (this.activechart == 1 && this.authlist.includes("007")) {
        this.gethotgoods();
      }
      localStorage.removeItem("maindataisshow");
      this.tippwdshow = false;
    } else {
      Toast("密码不正确");
    }
  }
  changechart(tag) {
    this.activechart = tag;
    if (tag == 0) {
      this.getchartdata();
    }
    if (tag == 1) {
      this.machart.dispose();
      this.gethotgoods();
    }
  }
  drawFun() {
    let dom = document.getElementById("ydxsqs");
    this.machart = echarts.init(dom);
    let option = {
      title: {
        text: "",
        bottom: 0,
        left: "center",
        textStyle: {
          color: "#7A8599",
          fontFamily: "PingFangSC",
          fontSize: 14,
          fontWeight: "bold",
        },
      },
      grid: {
        left: "2%",
        bottom: 0,
        right: "2%",
        containLabel: true,
      },
      tooltip: {
        trigger: "axis",
        formatter: `<div style="padding:1.1vw 2.2vw 1.1vw 1.46vw;background: #FFFFFF;box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.302);border-radius:5px;position:relative;"><div style="line-height:15.62px;margin-bottom:4px;color: #86909C;">{b}</div><div style="display:flex;align-items:flex-end;line-height:15.62px;color: #4E5969;font-size: 1.02vw;margin-top:0.73vw">销售额<div style="color: #FA5151;margin-left:0.73vw">￥</div><div style="color: #FA5151;font-size:1.46vw">{c}</div></div></div>`,
        axisPointer: {
          type: "none",
        },
        backgroundColor: "transparent",
        textStyle: {
          fontFamily: "PingFangSC",
          fontSize: 12,
        },
        padding: [5, 10],
        position: "inside",
        renderMode: "html",
      },
      xAxis: {
        type: "category",
        data: this.x_data,
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: true,
          color: "#3D3D3D",
          fontSize: 12,
          fontFamily: "PingFangSC",
          rotate: 45,
          interval: 0,
        },
        axisLine: {
          show: false,
          lineStyle: {
            color: "#E6E6E6",
            type: "dashed",
          },
        },
      },
      yAxis: {
        type: "value",
        axisLabel: {
          color: "#86909C",
          fontSize: 14,
          fontFamily: "PingFangSC",
        },
        axisTick: {
          show: false,
        },
        axisLine: {
          show: false,
        },
        splitLine: {
          lineStyle: {
            color: "#D8D8D8",
            type: "solid",
          },
        },
      },
      series: [
        {
          data: this.y_data,
          type: "line",
          barWidth: 19,
          barGap: 28,
          smooth: true,
          showSymbol: false,
          itemStyle: {
            color: "#CEB57D",
            emphasis: {
              color: "#CEB57D",
            },
          },
        },
      ],
    };
    option && this.machart.setOption(option);
    window.addEventListener("resize", () => {
      this.machart.resize();
    });
  }
  gotobb(tag) {
    let start = this.curseldate + "-01 00:00:00";
    let end = "";
    if (this.curseldate == dayjs(new Date()).format("YYYY-MM")) {
      end = dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59";
    } else {
      end =
        dayjs(this.curseldate).subtract(0, "month").endOf("month").format("YYYY-MM-DD") +
        " " +
        "23:59:59";
    }
    switch (tag) {
      case 1:
        if (!this.hasallAuth(["2601"])) {
          Toast("暂无销售报表查看权限，请联系管理员");
          return;
        }
        this.$router.push(`/pad/report/index?start=${start}&end=${end}`);
        break;
      case 2:
		  if (!this.hasallAuth(["1601"])) {
          Toast("暂无销售报表查看权限，请联系管理员");
          return;
        }
        this.$router.push(
          `/pad/report/index?tag=order&start=${start}&end=${end}&curZL=1`
        )
        break;
      case 3:
        if (!this.hasallAuth(["1701"])) {
          Toast("暂无商品报表查看权限，请联系管理员");
          return;
        }
        this.$router.push(`/pad/report/index?tag=goods&start=${start}&end=${end}`);
        break;
      	case 4:
		  if (!this.hasallAuth(["1601"])) {
        Toast("暂无销售报表查看权限，请联系管理员");
		    return;
		  }
		  this.$router.push(
		   `/pad/report/index?tag=order&start=${start}&end=${end}&curZL=2`
		  )
		  break;
		case 5:
		  if (!this.hasallAuth(["1701"])) {
        Toast("暂无商品报表查看权限，请联系管理员");
		    return;
		  }
		  this.$router.push(
		   `/pad/report/index?tag=goods&start=${start}&end=${end}&curZL=2`
		  )
		  break;

      default:
        break;
    }
  }
  gotovip() {
    if (!this.hasallAuth(["301", "401", "501"])) {
      Toast("暂无会员查看权限，请联系管理员");
      return;
    }
    let start = this.curseldate + "-01 00:00:00";
    let end = "";
    if (this.curseldate == dayjs(new Date()).format("YYYY-MM")) {
      end = dayjs(new Date()).format("YYYY-MM-DD") + " " + "23:59:59";
    } else {
      end =
        dayjs(this.curseldate).subtract(0, "month").endOf("month").format("YYYY-MM-DD") +
        " " +
        "23:59:59";
    }
    this.$router.push(`/pad/vip/index?start=${start}&end=${end}`);
  }
  /**判断是否开通网店 */
    async getOnlineAuth(){
        let res = await TbShop.GetOnlineIsOpen();
        if(res==true){
          this.isOnline = res;
          localStorage.setItem('isOnline',JSON.stringify(res))
          let res2 = await TbOrderPad.GetOnlineOrderListNum({
              shopId:this.userInfo['shopId'],
              isNotPickUpGoods:true,
              isPartPickUpGoods:true,
              orderStatus:2,
          })
          this.onlineOrderNum = res2.totalCount;
        }else{
          localStorage.removeItem('isOnline')
          this.isOnline = false;
          this.onlineOrderNum= 0;
        }
       
    }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/mainPage/mainPage.vue